import React from 'react'

export default props => (
    <div className='card-header' 
        style={{
            ...props.style, 
            padding: 8, 
            paddingLeft: props.paddingLeft, 
            paddingTop: props.paddingTop, 
            paddingRight: props.paddingRight, 
            paddingBottom: props.paddingBottom
        }}>
        {props.children}
    </div>
)
